<template>
	<div class="o-dashboard">

		<div class="o-dashboard__breadcrumbs">

			<c-breadcrumbs></c-breadcrumbs>

		</div>

		<div class="o-dashboard__panels">
			<div class="row collapse">
				<div class="column small-12 xlarge-8">

					<div class="c-panel c-panel--border c-panel--no-shadow margin-b-24">

						<h4 class="margin-b-32">{{role.name}}</h4>

						<c-splitbutton class="margin-b-24" :buttons="buttons"></c-splitbutton>

						<div class="row margin-b-16 fs-xsmall">
							<div class="columns small-12 medium-4">
								<span class="color-gray-600 font-heading">Omschrijving</span>
							</div>
							<div class="columns small-12 medium-8">
								{{role.description}}
							</div>
						</div>

						<div class="row margin-b-16 fs-xsmall">
							<div class="columns small-12 medium-4">
								<span class="color-gray-600 font-heading">Gebruikers</span>
							</div>
							<div class="columns small-12 medium-8" v-if="role.users">
								{{role.users.length}}
							</div>
						</div>

					</div>

					<div class="c-panel c-panel--border c-panel--no-shadow margin-b-24">
						<c-form @valid="submit" ref="form">
							<h4 class="margin-b-32">Rechten</h4>

							<c-checkbox
								:options="permissions"
								:horizontal="true"
								v-model="activePermissions"
							/>

							<div class="row collapse align-right">
								<div class="columns shrink">
									<c-button class="c-btn--expanded margin-t-32 margin-b-16" type="submit">opslaan</c-button>
								</div>
							</div>
						</c-form>
					</div>

				</div>
			</div>
		</div>

		<c-new-roles-rights v-if="role.name"
			v-show="modalEditRole"
			@close="modalEditRole = false"
			:size="'medium'"
			:edit="true"
			:role="role">
		</c-new-roles-rights>

		<c-remove-role
			v-show="modalRemoveRole"
			@close="modalRemoveRole = false"
			size="tiny"
			:item="role"
		/>

	</div>
</template>

<script>
import CTable from '@components/table/Table';
import Form from '@mixins/Form';
import CSplitbutton from '@components/Splitbutton';
import CBreadcrumbs from '@components/Breadcrumbs';
import CNewRolesRights from '@app/modals/NewRolesRights';
import CRemoveRole from '@app/modals/RemoveRole';
import CModal from '@components/Modal';
import { mapGetters, mapState } from 'vuex';

export default {
	mixins: [ Form ],
	components: { CSplitbutton, CTable, CBreadcrumbs, CNewRolesRights, CModal, CRemoveRole },
	data() {
		return {
			role: {},
			activePermissions: [],
			modalEditRole: false,
			modalRemoveRole: false,
		}
	},
	methods: {
		openModalEditRole() {
			this.modalEditRole = true;
		},
		openModalRemoveRole() {
			this.modalRemoveRole = true;
		},
		submit() {
			this.$store.dispatch('roles/save', {
				role: this.role,
				permissions: this.activePermissions,
			});
		},
	},
	created() {
		this.$store.dispatch('listener/on', {
			// event: 'new-roles-rights',
			listener: this.openModalEditRole
		});
		this.$store.dispatch('listener/on', {
			// event: 'new-roles-rights',
			listener: this.openModalRemoveRole
		});
	},
	beforeUnmount() {
		this.$store.dispatch('listener/on', {
			// event: 'new-roles-rights',
			listener: this.openModalEditRole
		});
		this.$store.dispatch('listener/on', {
			// event: 'new-roles-rights',
			listener: this.openModalRemoveRole
		});
	},
	computed: {
		buttons() {
			const buttons = [];
			this.can('Rol wijzigen') && buttons.push({
				label: 'Bewerken',
				action: () => {
					this.openModalEditRole();
				}
			});

			this.can('Rol verwijderen') && buttons.push({
				label: 'Verwijderen',
				action: () => {
					this.openModalRemoveRole();
				}
			});

			return buttons;
		},
		...mapState([
			'permissions',
		]),
		...mapGetters({
			can: 'user/can',
		}),
	},
	mounted() {

			this.$xhr.get('/api/roles/' + this.$route.params.id ).then( ({result}) => {

				this.role = result;
				this.activePermissions = result.permissions.map(p => p.id);

			}).catch((e) => {
				this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Rolgegevens kunnen niet worden ingeladen'});
			});
	},

}
</script>
